// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Product Analyzer confirm step. Header + overlay copied from chatModal.css so
   it reads as the same surface; fields are MUI (styled in the component). */

.pa-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
}

/* Same backdrop as chatModal: just darkened, no blur. */
.pa-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1299;
}

.pa-content {
  position: relative;
  z-index: 1301;
  width: 95%;
  max-width: 680px;
  max-height: 88vh;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  padding: 10px;
}

/* ── Header - copied from chatModal.css (.chat-modal-header*) ───────────── */
.pa-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 2px 0px 8px 8px;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 4px;
}
.pa-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.pa-header-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.pa-title {
  font-size: 16px;
  font-weight: 600;
  color: #20202a;
  line-height: 1.2;
}
.pa-subtitle {
  font-size: 12px;
  color: #82828e;
  line-height: 1.3;
}
.pa-header-ic {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #f3f0fc;
  color: #5616ea;
  font-size: 14px;
  flex-shrink: 0;
}
.pa-close {
  background: none;
  border: none;
  font-size: 20px;
  color: #888;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 6px;
  transition: all 0.2s ease;
  line-height: 1;
}
.pa-close:hover { background: #f0f0f0; color: #333; }
.pa-close:disabled { opacity: 0.4; cursor: default; }

/* Loading / empty */
.pa-loading {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 14px; padding: 64px 20px; color: #6f6a85; text-align: center; flex: 1 1;
}
.pa-spinner { font-size: 34px; color: #5616ea; }

/* ── File tabs (multi-file) - pills, fully visible, never clipped ──────── */
.pa-tabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  flex-shrink: 0;
  padding: 10px 8px 4px;
}
.pa-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  max-width: 220px;
  padding: 8px 13px;
  font-size: 12.5px;
  font-family: inherit;
  color: #5b5670;
  background: #f4f2fb;
  border: 1px solid #e7e3f3;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}
.pa-tab:hover { background: #ece7f8; }
.pa-tab-active {
  background: #f3f0fc;
  color: #5616ea;
  font-weight: 600;
  border-color: #d4c6f7;
}
.pa-tab svg { font-size: 12px; flex-shrink: 0; }
.pa-tab-label { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* ── Body ──────────────────────────────────────────────────────────────────
   Horizontal padding matches the tabs (.pa-tabs padding-left/right: 8px) so the
   count, sections and field cards line up with the tabs' left/right edges. */
.pa-body { padding: 14px 8px 24px; overflow-y: auto; flex: 1 1; }

/* Product count only (no icon / filename). */
.pa-count {
  display: inline-block;
  font-size: 11.5px; font-weight: 600; color: #5616ea;
  background: #f3f0fc; padding: 4px 11px; border-radius: 10px;
  margin-bottom: 18px;
}

/* Shared section header (Catalog + Fields use the identical structure). */
.pa-section-head { display: flex; flex-direction: column; gap: 3px; margin-bottom: 12px; }
.pa-section-head-fields { margin-top: 26px; }
.pa-section-title { font-size: 13.5px; font-weight: 700; color: #2a2640; }
.pa-section-sub { font-size: 11.5px; color: #8a8699; line-height: 1.4; }

.pa-field { margin-bottom: 14px; }

.pa-cols { display: flex; flex-direction: column; gap: 10px; }
.pa-col {
  display: flex; flex-direction: column; gap: 10px;
  border: 1px solid #ececf3; border-radius: 10px;
  padding: 12px 14px 14px; background: #fcfbff;
  transition: opacity 0.15s, background 0.15s, border-color 0.15s;
  padding-top: 6px;
}
.pa-col-off { opacity: 0.55; background: #f7f7fa; }

/* Identity line: include-toggle + field name + raw key + type + examples,
   all on one baseline so every row lines up. */
.pa-col-top { display: flex; align-items: center; gap: 9px; flex-wrap: wrap; min-height: 22px; }
.pa-col-name { font-size: 14px; font-weight: 600; color: #1a1730; }
.pa-col-key {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 11.5px; font-weight: 500; color: #6b6580;
  background: #f1eef8; padding: 1px 7px; border-radius: 6px;
}
.pa-col-type {
  font-size: 10px; text-transform: uppercase; letter-spacing: 0.04em;
  padding: 2px 7px; border-radius: 6px; font-weight: 700;
}
.pa-col-type-number { color: #1668c2; background: #e4f0ff; }
.pa-col-type-text { color: #6b6580; background: #efedf6; }
.pa-col-samples {
  font-size: 11.5px; color: #9a96a8; margin-left: auto;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 45%;
}

/* The include toggle is a MUI Switch (styled inline like deploy → Design). Pull
   it left so its track lines up with the card's left padding, not MUI's. */
.pa-col-top .MuiSwitch-root { margin-left: -8px; flex-shrink: 0; }

.pa-error {
  display: flex; align-items: center; gap: 8px; color: #b4453a;
  background: #fdeceb; border: 1px solid #f6cfcb; border-radius: 10px; padding: 10px 12px; font-size: 13px;
}

/* ── Footer ────────────────────────────────────────────────────────────── */
.pa-footer {
  display: flex; justify-content: flex-end; gap: 10px;
  padding: 12px 8px 6px; border-top: 1px solid #efedf6; flex-shrink: 0;
}
.pa-btn {
  border: none; border-radius: 10px; padding: 9px 18px; font-size: 13.5px; font-weight: 600;
  cursor: pointer; font-family: inherit; display: inline-flex; align-items: center; gap: 7px;
  transition: background 0.15s, transform 0.1s;
}
.pa-btn-secondary { background: #f1eef9; color: #4a4560; }
.pa-btn-secondary:hover { background: #e7e2f5; }
.pa-btn-primary { background: #5616ea; color: #fff; }
.pa-btn-primary:hover { background: #4a12c9; }
.pa-btn-primary:active { transform: scale(0.97); }
.pa-btn-primary:disabled { opacity: 0.45; cursor: default; }

@media (max-width: 600px) {
  .pa-content { max-height: 94vh; }
  .pa-subtitle { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProductAnalyzerModal.css"],"names":[],"mappings":"AAAA;4EAC4E;;AAE5E;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,wDAAwD;AACxD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;AACf;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,wBAAwB;EACxB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;AACA,kBAAkB,mBAAmB,EAAE,WAAW,EAAE;AACpD,qBAAqB,YAAY,EAAE,eAAe,EAAE;;AAEpD,oBAAoB;AACpB;EACE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,uBAAuB;EACnF,SAAS,EAAE,kBAAkB,EAAE,cAAc,EAAE,kBAAkB,EAAE,SAAO;AAC5E;AACA,cAAc,eAAe,EAAE,cAAc,EAAE;;AAE/C,6EAA6E;AAC7E;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,6DAA6D;AAC/D;AACA,gBAAgB,mBAAmB,EAAE;AACrC;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA,cAAc,eAAe,EAAE,cAAc,EAAE;AAC/C,gBAAgB,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAEhF;;6EAE6E;AAC7E,WAAW,sBAAsB,EAAE,gBAAgB,EAAE,SAAO,EAAE;;AAE9D,6CAA6C;AAC7C;EACE,qBAAqB;EACrB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc;EACnD,mBAAmB,EAAE,iBAAiB,EAAE,mBAAmB;EAC3D,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACzF,0BAA0B,gBAAgB,EAAE;AAC5C,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACzE,kBAAkB,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAEvE,YAAY,mBAAmB,EAAE;;AAEjC,WAAW,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC7D;EACE,aAAa,EAAE,sBAAsB,EAAE,SAAS;EAChD,yBAAyB,EAAE,mBAAmB;EAC9C,uBAAuB,EAAE,mBAAmB;EAC5C,+DAA+D;EAC/D,gBAAgB;AAClB;AACA,cAAc,aAAa,EAAE,mBAAmB,EAAE;;AAElD;+CAC+C;AAC/C,cAAc,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC/F,eAAe,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAClE;EACE,2DAA2D;EAC3D,iBAAiB,EAAE,gBAAgB,EAAE,cAAc;EACnD,mBAAmB,EAAE,gBAAgB,EAAE,kBAAkB;AAC3D;AACA;EACE,eAAe,EAAE,yBAAyB,EAAE,sBAAsB;EAClE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB;AACxD;AACA,sBAAsB,cAAc,EAAE,mBAAmB,EAAE;AAC3D,oBAAoB,cAAc,EAAE,mBAAmB,EAAE;AACzD;EACE,iBAAiB,EAAE,cAAc,EAAE,iBAAiB;EACpD,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,cAAc;AAChF;;AAEA;2EAC2E;AAC3E,8BAA8B,iBAAiB,EAAE,cAAc,EAAE;;AAEjE;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc;EAC5D,mBAAmB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,eAAe;AAC1G;;AAEA,6EAA6E;AAC7E;EACE,aAAa,EAAE,yBAAyB,EAAE,SAAS;EACnD,qBAAqB,EAAE,6BAA6B,EAAE,cAAc;AACtE;AACA;EACE,YAAY,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,gBAAgB;EACzF,eAAe,EAAE,oBAAoB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EAC1F,4CAA4C;AAC9C;AACA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,0BAA0B,mBAAmB,EAAE;AAC/C,kBAAkB,mBAAmB,EAAE,WAAW,EAAE;AACpD,wBAAwB,mBAAmB,EAAE;AAC7C,yBAAyB,sBAAsB,EAAE;AACjD,2BAA2B,aAAa,EAAE,eAAe,EAAE;;AAE3D;EACE,cAAc,gBAAgB,EAAE;EAChC,eAAe,aAAa,EAAE;AAChC","sourcesContent":["/* Product Analyzer confirm step. Header + overlay copied from chatModal.css so\r\n   it reads as the same surface; fields are MUI (styled in the component). */\r\n\r\n.pa-modal {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1300;\r\n}\r\n\r\n/* Same backdrop as chatModal: just darkened, no blur. */\r\n.pa-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 1299;\r\n}\r\n\r\n.pa-content {\r\n  position: relative;\r\n  z-index: 1301;\r\n  width: 95%;\r\n  max-width: 680px;\r\n  max-height: 88vh;\r\n  background-color: #fff;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);\r\n  overflow: hidden;\r\n  padding: 10px;\r\n}\r\n\r\n/* ── Header - copied from chatModal.css (.chat-modal-header*) ───────────── */\r\n.pa-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-shrink: 0;\r\n  padding: 2px 0px 8px 8px;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  margin-bottom: 4px;\r\n}\r\n.pa-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  min-width: 0;\r\n}\r\n.pa-header-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n  min-width: 0;\r\n}\r\n.pa-title {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #20202a;\r\n  line-height: 1.2;\r\n}\r\n.pa-subtitle {\r\n  font-size: 12px;\r\n  color: #82828e;\r\n  line-height: 1.3;\r\n}\r\n.pa-header-ic {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 8px;\r\n  background: #f3f0fc;\r\n  color: #5616ea;\r\n  font-size: 14px;\r\n  flex-shrink: 0;\r\n}\r\n.pa-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 20px;\r\n  color: #888;\r\n  cursor: pointer;\r\n  padding: 2px 6px;\r\n  border-radius: 6px;\r\n  transition: all 0.2s ease;\r\n  line-height: 1;\r\n}\r\n.pa-close:hover { background: #f0f0f0; color: #333; }\r\n.pa-close:disabled { opacity: 0.4; cursor: default; }\r\n\r\n/* Loading / empty */\r\n.pa-loading {\r\n  display: flex; flex-direction: column; align-items: center; justify-content: center;\r\n  gap: 14px; padding: 64px 20px; color: #6f6a85; text-align: center; flex: 1;\r\n}\r\n.pa-spinner { font-size: 34px; color: #5616ea; }\r\n\r\n/* ── File tabs (multi-file) - pills, fully visible, never clipped ──────── */\r\n.pa-tabs {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n  flex-shrink: 0;\r\n  padding: 10px 8px 4px;\r\n}\r\n.pa-tab {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  max-width: 220px;\r\n  padding: 8px 13px;\r\n  font-size: 12.5px;\r\n  font-family: inherit;\r\n  color: #5b5670;\r\n  background: #f4f2fb;\r\n  border: 1px solid #e7e3f3;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\r\n}\r\n.pa-tab:hover { background: #ece7f8; }\r\n.pa-tab-active {\r\n  background: #f3f0fc;\r\n  color: #5616ea;\r\n  font-weight: 600;\r\n  border-color: #d4c6f7;\r\n}\r\n.pa-tab svg { font-size: 12px; flex-shrink: 0; }\r\n.pa-tab-label { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\r\n\r\n/* ── Body ──────────────────────────────────────────────────────────────────\r\n   Horizontal padding matches the tabs (.pa-tabs padding-left/right: 8px) so the\r\n   count, sections and field cards line up with the tabs' left/right edges. */\r\n.pa-body { padding: 14px 8px 24px; overflow-y: auto; flex: 1; }\r\n\r\n/* Product count only (no icon / filename). */\r\n.pa-count {\r\n  display: inline-block;\r\n  font-size: 11.5px; font-weight: 600; color: #5616ea;\r\n  background: #f3f0fc; padding: 4px 11px; border-radius: 10px;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n/* Shared section header (Catalog + Fields use the identical structure). */\r\n.pa-section-head { display: flex; flex-direction: column; gap: 3px; margin-bottom: 12px; }\r\n.pa-section-head-fields { margin-top: 26px; }\r\n.pa-section-title { font-size: 13.5px; font-weight: 700; color: #2a2640; }\r\n.pa-section-sub { font-size: 11.5px; color: #8a8699; line-height: 1.4; }\r\n\r\n.pa-field { margin-bottom: 14px; }\r\n\r\n.pa-cols { display: flex; flex-direction: column; gap: 10px; }\r\n.pa-col {\r\n  display: flex; flex-direction: column; gap: 10px;\r\n  border: 1px solid #ececf3; border-radius: 10px;\r\n  padding: 12px 14px 14px; background: #fcfbff;\r\n  transition: opacity 0.15s, background 0.15s, border-color 0.15s;\r\n  padding-top: 6px;\r\n}\r\n.pa-col-off { opacity: 0.55; background: #f7f7fa; }\r\n\r\n/* Identity line: include-toggle + field name + raw key + type + examples,\r\n   all on one baseline so every row lines up. */\r\n.pa-col-top { display: flex; align-items: center; gap: 9px; flex-wrap: wrap; min-height: 22px; }\r\n.pa-col-name { font-size: 14px; font-weight: 600; color: #1a1730; }\r\n.pa-col-key {\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\r\n  font-size: 11.5px; font-weight: 500; color: #6b6580;\r\n  background: #f1eef8; padding: 1px 7px; border-radius: 6px;\r\n}\r\n.pa-col-type {\r\n  font-size: 10px; text-transform: uppercase; letter-spacing: 0.04em;\r\n  padding: 2px 7px; border-radius: 6px; font-weight: 700;\r\n}\r\n.pa-col-type-number { color: #1668c2; background: #e4f0ff; }\r\n.pa-col-type-text { color: #6b6580; background: #efedf6; }\r\n.pa-col-samples {\r\n  font-size: 11.5px; color: #9a96a8; margin-left: auto;\r\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 45%;\r\n}\r\n\r\n/* The include toggle is a MUI Switch (styled inline like deploy → Design). Pull\r\n   it left so its track lines up with the card's left padding, not MUI's. */\r\n.pa-col-top .MuiSwitch-root { margin-left: -8px; flex-shrink: 0; }\r\n\r\n.pa-error {\r\n  display: flex; align-items: center; gap: 8px; color: #b4453a;\r\n  background: #fdeceb; border: 1px solid #f6cfcb; border-radius: 10px; padding: 10px 12px; font-size: 13px;\r\n}\r\n\r\n/* ── Footer ────────────────────────────────────────────────────────────── */\r\n.pa-footer {\r\n  display: flex; justify-content: flex-end; gap: 10px;\r\n  padding: 12px 8px 6px; border-top: 1px solid #efedf6; flex-shrink: 0;\r\n}\r\n.pa-btn {\r\n  border: none; border-radius: 10px; padding: 9px 18px; font-size: 13.5px; font-weight: 600;\r\n  cursor: pointer; font-family: inherit; display: inline-flex; align-items: center; gap: 7px;\r\n  transition: background 0.15s, transform 0.1s;\r\n}\r\n.pa-btn-secondary { background: #f1eef9; color: #4a4560; }\r\n.pa-btn-secondary:hover { background: #e7e2f5; }\r\n.pa-btn-primary { background: #5616ea; color: #fff; }\r\n.pa-btn-primary:hover { background: #4a12c9; }\r\n.pa-btn-primary:active { transform: scale(0.97); }\r\n.pa-btn-primary:disabled { opacity: 0.45; cursor: default; }\r\n\r\n@media (max-width: 600px) {\r\n  .pa-content { max-height: 94vh; }\r\n  .pa-subtitle { display: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
